import {
  Box, Checkbox, ListItem, Text,
} from '@domain-group/suit-theme'

interface DisclaimerProps {
  acceptanceRequired?: boolean,
  checked: boolean,
  disclaimerBody: string,
  disclaimerTitle: string,
  onClick?: VoidFunction,
}

const Disclaimer = (props: DisclaimerProps) => {
  const {
    acceptanceRequired,
    checked,
    disclaimerBody,
    disclaimerTitle,
    onClick,
  } = props

  return (
    <ListItem boxProps={{ borderBottom: '1px dashed', paddingY: 'large' }} disableHover>
      <Box width="auto">
        <Checkbox checked={checked} onClick={acceptanceRequired ? onClick : null} />
      </Box>
      <Box flexDirection="column">
        <Text fontSize="small">{disclaimerTitle}</Text>
        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          lineHeight="1.3"
          marginTop="small"
          style={{ whiteSpace: 'pre-wrap' }}
        >
          {disclaimerBody}
        </Text>
      </Box>
    </ListItem>
  )
}

export default Disclaimer
